import { render, staticRenderFns } from "./club-moment.vue?vue&type=template&id=3bc40906&scoped=true&"
import script from "./club-moment.vue?vue&type=script&lang=js&"
export * from "./club-moment.vue?vue&type=script&lang=js&"
import style0 from "./club-moment.vue?vue&type=style&index=0&id=3bc40906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc40906",
  null
  
)

export default component.exports